<h2>{{ "i18n.dashboard.title" | translate }}</h2>
<div class="ob-grid">
	<div class="ob-span-3">
		<mat-card appearance="outlined">
			<mat-card-header>
				<mat-card-title>{{ "i18n.dashboard.card.usertasks.title" | translate }}</mat-card-title>
				<mat-card-subtitle>{{ "i18n.dashboard.subtitle.usertasks.description" | translate }}</mat-card-subtitle>
			</mat-card-header>
			<mat-card-content>
				<div class="card-content-container">
					@for (item of catalogUserData; track item) {
					<div>
						@if (item?.reference; as reference) {
						<a class="mat-chip-section link-as-text" [routerLink]="['/catalog']" [queryParams]="{ query: userEmailQuery, types: item?.reference }">
							<span>{{ "i18n.dashboard.card.agencydata.type." + reference.replace(" ", "").toLowerCase() | translate }}</span>
							<mat-chip-set class="mat-chip-counter">
								<mat-chip class="info">{{ item?.count }}</mat-chip>
							</mat-chip-set>
						</a>
						}
					</div>
					}
				</div>
			</mat-card-content>
		</mat-card>
	</div>

	<div class="ob-span-3">
		<mat-card appearance="outlined">
			<mat-card-header>
				<mat-card-title>{{ "i18n.dashboard.card.proposals.title" | translate }}</mat-card-title>
				<mat-card-subtitle>{{ "i18n.dashboard.subtitle.proposals.description" | translate }}</mat-card-subtitle>
			</mat-card-header>
			<mat-card-content>
				<div class="card-content-container">					
					@for (item of catalogAgencyPenndingLevels; track item) {
					<div>
						@if (item?.reference; as reference) {
						<a
							class="mat-chip-section link-as-text"
							[routerLink]="['/catalog']"
							[queryParams]="{ publisher: publishersIdendifier, levelProposals: item?.reference }"
						>
							<span>{{ "i18n.title.proposed_as" | translate }} {{ getPublicationLevelKey(reference) | translate }}</span>
							<mat-chip-set class="mat-chip-counter">
								<mat-chip class="info">{{ item?.count }}</mat-chip>
							</mat-chip-set>
						</a>
						}
					</div>
					} @for (item of catalogAgencyPenndingStatuses; track item) {
					<div>
						@if (item?.reference; as reference) {
						<a
							class="mat-chip-section link-as-text"
							[routerLink]="['/catalog']"
							[queryParams]="{ publisher: publishersIdendifier, statusProposals: item?.reference }"
						>
							<span>{{ "i18n.title.proposed_as" | translate }} {{ getRegistrationStatusKey(reference) | translate }}</span>
							<mat-chip-set class="mat-chip-counter">
								<mat-chip class="info">{{ item?.count }}</mat-chip>
							</mat-chip-set>
						</a>
						}
					</div>
					}
				</div>
			</mat-card-content>
		</mat-card>
	</div>

	<div class="ob-span-3">
		<mat-card appearance="outlined">
			<mat-card-header>
				<mat-card-title>{{ "i18n.dashboard.card.agencydata.title" | translate }}</mat-card-title>
				<mat-card-subtitle>{{ "i18n.dashboard.subtitle.agencydata.description" | translate }}</mat-card-subtitle>
			</mat-card-header>
			<mat-card-content>
				<div class="card-content-container">
					@for (item of catalogAgencyData; track item) {
					<div>
						@if (item?.reference; as reference) {
						<a class="mat-chip-section link-as-text" [routerLink]="['/catalog']" [queryParams]="{ publisher: publishersIdendifier, types: item?.reference }">
							<span>{{ "i18n.dashboard.card.agencydata.type." + reference.replace(" ", "").toLowerCase() | translate }}</span>
							<mat-chip-set class="mat-chip-counter">
								<mat-chip class="info">{{ item?.count }}</mat-chip>
							</mat-chip-set>
						</a>
						}
					</div>
					}
				</div>
			</mat-card-content>
		</mat-card>
	</div>
</div>
